// extracted by mini-css-extract-plugin
module.exports = {"block":"_19412","hd":"_16399","title":"_18602","arrow":"_7201","empty":"_19629","bd":"_11070","ft":"_4342"};